import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IActionPartner,
  IPeriodoUltimos12Meses,
  IPeriodoUltimos12MesesParnter,
} from './interfaces/apiInterfaces';
import { IInitialState, ILastTwelveMonths } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  cartaoSent: {
    value: 0,
    quantity: 0,
  },
  cartaoReceived: {
    value: 0,
    quantity: 0,
  },
  lastTwelveMonths: [],
};

export const getCartaoFaresFromApi = createAction(
  '@faresApp/cartaoFares/GET_CARTAO_FARES_FROM_API'
);

export const gotCartaoFaresFromApi = createAction<any>(
  '@faresApp/cartaoFares/GOT_CARTAO_FARES_FROM_API'
);

export const gotCartaoFaresPartnerFromApi = createAction<any>(
  '@faresApp/cartaoFares/GOT_CARTAO_FARES_PARTNER_FROM_API'
);

export const gotErrorFromCartaoFaresApi = createAction(
  '@faresApp/cartaoFares/GOT_ERROR_FROM_CARTAO_FARES_API'
);

export const displayCartaoFares = createAction<boolean>(
  '@faresApp/cartaoFares/DISPLAY_CARTAO_FARES'
);

export const logoutCartaoFaresApp = createAction(
  '@faresApp/cartaoFares/LOGOUT_CARTAO_FARES_APP'
);

const cartaoFaresReducer = createReducer(INITIAL_STATE, {
  [getCartaoFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
    partner: false,
  }),
  [gotCartaoFaresPartnerFromApi.type]: (state, action: IActionPartner) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: true,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    cartaoSent: {
      value: action.payload.cartao_enviada.valor,
      quantity: action.payload.cartao_enviada.quantidade,
    },
    cartaoReceived: {
      value: action.payload.cartao_recebida.valor,
      quantity: action.payload.cartao_recebida.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12MesesParnter) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.cartao_enviada.valor,
            quantity: mes.cartao_enviada.quantidade,
          },
          faresReceived: {
            value: mes.cartao_recebida.valor,
            quantity: mes.cartao_recebida.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotCartaoFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    cartaoSent: {
      value: action.payload.fiducia_clientes_enviadas.valor,
      quantity: action.payload.fiducia_clientes_enviadas.quantidade,
    },
    cartaoReceived: {
      value: action.payload.fiducia_wl_recebidos.valor,
      quantity: action.payload.fiducia_wl_recebidos.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12Meses) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.fiducia_clientes_enviadas.valor,
            quantity: mes.fiducia_clientes_enviadas.quantidade,
          },
          faresReceived: {
            value: mes.fiducia_wl_recebidos.valor,
            quantity: mes.fiducia_wl_recebidos.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotErrorFromCartaoFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
    partner: false,
  }),
  [displayCartaoFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutCartaoFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    partner: false,
    dateSearch: {
      start: '',
      end: '',
    },
  }),
});

export default cartaoFaresReducer;
